// Dependencies
import { createStitches } from '@stitches/react';

export const { styled } = createStitches();
